import {
  LOCAL_STORAGE_KEY,
  getValueFromStorageByKey,
} from "@/utils/localStorage";

export const hasPermission = (permissions, permissionPolicy) => {
  const filteredPermission =
    permissions &&
    permissions.filter(
      (permissionItem) => permissionItem.Permissions === permissionPolicy
    );
  return filteredPermission && filteredPermission.length > 0;
};

export const hasPermissionUser = (permissionPolicy) => {
  if (permissionPolicy) {
    const permissions = getValueFromStorageByKey(
      LOCAL_STORAGE_KEY.PERMISSION_DECENTRALIZATION
    );
    const filteredPermission =
      permissions &&
      permissions.Permissions.filter(
        (permissionItem) => permissionItem.Permissions === permissionPolicy
      );
    return filteredPermission && filteredPermission.length > 0;
  }
  return true;
};
